import { lazy } from 'react'

export const WeightGain = lazy(() => import('./WeightGain'))
